import { useAccountPreferences } from '~publish/contexts/AccountContext'
import type { StartOfWeek } from '~publish/gql/graphql'

export const useWeekStartsOn = (): StartOfWeek => {
  const preferences = useAccountPreferences()
  return preferences?.startOfWeek === 'sunday' ? 'sunday' : 'monday'
}
